import { useQuery } from 'react-query';

import { workScheduleQueryKeys } from './queryKeys';
import { fetchParentWorkSchedules } from './workScheduleApi';

export const useParentWorkSchedulesQuery = ({ companyId }, options) =>
  useQuery(
    workScheduleQueryKeys.parentSchedules(companyId),
    () => fetchParentWorkSchedules({ companyId }),
    {
      enabled: Boolean(companyId),
      initialData: [],
      ...options,
    }
  );
